import { ClassroomLocation, Info, Profile as IconProfile, WarningTriangle } from '@berlitz/icons'
import { BookFlip } from '@berlitz/icons'
import Spacer from '@berlitz/spacer'
import CalendarSearch from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/21-Date-Calendar/CalendarSearch'
import PerfTablet from '@berlitz/streamline-icons/lib/regular/06-Business-Products/11-Performances/PerformanceTabletIncrease'
import Building from '@berlitz/streamline-icons/lib/regular/49-Building-Construction/03-Buildings/Building1'
import MyBerlitzLesson from '@classes/Lesson'
import PortalStudentProfile from '@classes/StudentProfile'
import JoinLessonButton from '@components/JoinLessonButton'
import { LessonTypeIcon, ListCard } from '@components/ListCard'
import { LessonDate } from '@components/ListCard/style'
import { GroupProfileModal, SingleProfileModal } from '@components/Modal'
import SelfTechCheck from '@components/SelfTechCheck'
import { TableLoader } from '@components/Table'
import { ToasterProps, withToaster } from '@components/Toaster'
import Tooltip from '@components/Tooltip'
import ViewMaterialError from '@components/ViewMaterial/Error'
import ViewMaterialLoader from '@components/ViewMaterial/Loader'
import QueryMaterialData from '@components/ViewMaterial/QueryMaterialData'
import WithLessonUtilsHOC, { WithLessonUtilsProp } from '@hocs/WithLessonUtils'
import WithUserTime, { WithUserTimeProps } from '@hocs/WithUserTime'
import { SessionInfoList as ISessionInfoList } from '@interfaces/LessonGroups'
import { GroupClassListItem } from '@interfaces/MySchedule'
import { StudentProfileInfo } from '@interfaces/Student'
import EventJoinOnlineBtn from '@layouts/Events/EventJoinOnlineBtn'
import RecordTableContainer from '@layouts/LessonRegistration/RecordTable/RecordTableContainer'
import { StyledH2 } from '@layouts/LessonRegistration/RecordTable/style'
import { DATE_FORMAT } from '@utils/constants'
import { getAtRiskData } from '@utils/helpers/instructor-scheduling'
import { getEarliestFromDate } from '@utils/helpers/lesson-history'
import { isFlexProgram, isBoD1 } from '@utils/helpers/sessions'
import { nonLessons } from '@utils/lesson-type'
import { isEmpty } from 'lodash'
import first from 'lodash/first'
import get from 'lodash/get'
import includes from 'lodash/includes'
import lowerFirst from 'lodash/lowerFirst'
import map from 'lodash/map'
import moment from 'moment-timezone'
import Link from 'next/link'
import React from 'react'
// @ts-ignore
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl'
import { Col, Row } from 'react-styled-flexboxgrid'
import { compose } from 'redux'
import Materials from '../Materials'
import Notes from '../Notes'
import NotesError from '../Notes/Error'
import NotesLoader from '../Notes/Loader'
import QueryNotesData from '../QueryNotesData'
import QueryProfilesData from '../QueryProfilesData'
import StudyPurpose from '../StudyPurpose'
import StudyPurposeError from '../StudyPurpose/Error'
import Indicators from './Indicators'
import { LessonProp } from './interface'
import QueryLessonDetail from './QueryLessonDetail'
import {
  AtRiskContainer,
  AtRiskText,
  Container,
  Content,
  ContentBox,
  EventJoinOnlineBtnWrapper,
  EventOpenMaterialBtnWrapper,
  GroupedName,
  IndicatorsRow,
  LessonProfile,
  MiniProgramName,
  MyLessonEvent,
  RecordTableOverride,
  RightCol,
  StyledCol,
  StyledRow,
  Time,
} from './style'
import PortalTimeFormat from '@components/PortalTimeFormat'
import EventOpenMaterialBtn from '@layouts/Events/EventOpenMaterialBtn'
import { EVENT_ATTENDEE_ROLE_HOST } from '@layouts/Events/constants'
import EventOpenMaterialModal from '@layouts/Events/EventOpenMaterialModal'
import { GROUP_CONVERSATION_CLASS } from '@utils/constants/events'

// import BpsStatus from './BpsStatus'

interface LessonState {
  groupId: string
  groupName: string | null | undefined
  programId: string
  language: string
  modalProfileOpen: boolean
  isIndividual: boolean
  collapsedItems: string[]
  sessionInfoList: ISessionInfoList[]
  modalEventMaterialError: boolean
}

const nlt = nonLessons.map((lesson) => lesson.toLowerCase())

class Lessons extends React.PureComponent<
  LessonProp & WithUserTimeProps & InjectedIntlProps & ToasterProps & WithLessonUtilsProp,
  LessonState
> {
  state = {
    groupId: '',
    groupName: '',
    programId: '',
    language: '',
    modalProfileOpen: false,
    isIndividual: false,
    collapsedItems: [],
    sessionInfoList: [],
    modalEventMaterialError: false,
  }

  handleViewProfile = (
    groupId: string,
    groupName: string | null | undefined,
    programId: string,
    language: string,
    modal: boolean,
    isIndividual: boolean,
    SessionInfoList: ISessionInfoList[]
  ) => {
    this.setState({
      groupId,
      groupName,
      programId,
      language,
      modalProfileOpen: modal,
      isIndividual,
      sessionInfoList: SessionInfoList,
    })
  }

  renderIcon = (type: string, customType?: string, darkIcon?: boolean) => (
    <LessonTypeIcon typeName={type} darkText={false} customLabel={customType} labelStyle="badge" darkIcon={darkIcon} />
  )

  isPastTime = (endTime: string) => {
    const { profile } = this.props
    const et = moment(moment.utc(endTime, DATE_FORMAT.DT).toDate()).tz(profile.Timezone)
    return moment(et).isBefore(moment())
  }

  getStatusIndicator = (status: string | null | undefined, endTime: string, isAbsent: boolean) => {
    const color = get(
      {
        completed: 'disabled',
        confirmed: 'success',
        cancelled: 'error',
        pending: 'pending',
        rejected: 'error',
      },
      (status || '').toLowerCase()
    )

    if (['completed', 'confirmed'].includes((status || '').toLowerCase()) && isAbsent) {
      return 'error'
    }

    return color !== 'error' && this.isPastTime(endTime) ? 'disabled' : color
  }

  queryDateFormat = (val: string) => moment.utc(val, DATE_FORMAT.DT).format()
  identifyLocation = (
    location: string | null | undefined,
    type: string,
    provider?: string | null
  ) => {
    let loc = location

    const lType = (type || '').toLowerCase()
    if (lType.includes('online')) {
      loc = 'Online'
    }
    // Add provider only if exists
    if (provider) {
      return `${loc} (${provider})`
    }
    return loc
  }

  render() {
    const {
      intl,
      data: dataProp,
      instructor,
      startDate,
      endDate,
      toUserDate,
      getUserDate,
      isCutOff,
      setAttachments,
      setOpenFileModal,
      setOpenNoteModal,
      setNote,
      recordId,
    } = this.props
    const {
      groupId,
      groupName,
      programId,
      language,
      modalProfileOpen,
      isIndividual,
      collapsedItems,
      sessionInfoList,
      modalEventMaterialError,
    } = this.state

    const recId = recordId ? `&recordId=${recordId}` : ''
    return (
      <Container>
        {[...dataProp.GroupClassList]
          .sort((a, b) => {
            const timezone = this.props.profile.Timezone
            const aStart = moment.utc(a.StartTime, DATE_FORMAT.DT).tz(timezone)
            const bStart = moment.utc(b.StartTime, DATE_FORMAT.DT).tz(timezone)
            return aStart.diff(bStart)
          })
          .map((groupClass, index) => {
            const {
              GroupName,
              Type = 'unknown',
              ProgramId,
              LearningCenter,
              Classroom,
              // Bps,
              // FirstLesson,
              // HighestRating,
              // PaceWarning,
              // ReportNeeded,
              // Attachment,
              Status,
              // DisplayTime,
              // Warning,
              SessionId,
              SessionInfoList,
              StudentGroupId,
              // Notes: notes,
              ProgramType,
              StartTime,
              EndTime,
              LessonRegistered,
              LastMaterialList,
              MaterialList,
              SessionMetaData,
              MINote,
              DeliveryMode,
              Id,
              Language,
              TotalLessons,
              LessonsTaken,
              LessonsRemaining,
              StudentProfile,
              MaxNumberofStudentsInGroup,
            } = groupClass as GroupClassListItem

            const SimpleProfile: undefined | PortalStudentProfile =
              StudentProfile && new PortalStudentProfile(StudentProfile as StudentProfileInfo)
            const ProgramReg = SimpleProfile?.Programs?.[ProgramId]?.program
            const session = new MyBerlitzLesson(SessionInfoList[0] as any)
            const st = toUserDate(StartTime, DATE_FORMAT.DT, 'HH:mm')
            const ed = toUserDate(EndTime, DATE_FORMAT.DT, 'HH:mm')
            const isProgramOnline = DeliveryMode

            const currentDate = getUserDate()
            const lessonEndDate = moment.utc(currentDate).format()
            const isCollapsed = includes(collapsedItems, Id)
            const atRiskData = getAtRiskData(SessionInfoList, LessonsRemaining)
            const DisplayDate = toUserDate(StartTime, DATE_FORMAT.DT, DATE_FORMAT.DEFAULT)
            const DisplayTime = `${st} - ${ed}`

            /**
             * Jorge Diaz
             * We had a discussion and it seems that my lessons requires a bit more of thinking
             * So we are going to leave it out of scope for the time being
             * We will create a new one when the design my lessons is ready
             * const isAbsent = every(SessionInfoList, { Attendance: 'Absent' })
             **/
            const isAbsent = false

            const schedStartDate = toUserDate(StartTime, DATE_FORMAT.DT, DATE_FORMAT.SIMPLE)
            const crossOverDate =
              schedStartDate === toUserDate(EndTime, DATE_FORMAT.DT, DATE_FORMAT.SIMPLE) ? null : schedStartDate

            let lessonsRemaining = 0
            if (TotalLessons - LessonsTaken > 0) {
              lessonsRemaining = TotalLessons - LessonsTaken
            }

            return (
              <Spacer bottom size="md" key={index}>
                <AtRiskContainer isAtRisk={Boolean(atRiskData.length)}>
                  <ListCard
                    bordered
                    icon={this.renderIcon(
                      Type + (MaxNumberofStudentsInGroup ? ` (${MaxNumberofStudentsInGroup})` : ''),
                      session.LCSTitle,
                      this.getStatusIndicator(Status, EndTime, isAbsent) === 'disabled' &&
                      Type === GROUP_CONVERSATION_CLASS
                    )}
                    color={this.getStatusIndicator(Status, EndTime, isAbsent)}
                    iconLabel={!groupClass?.Event ? ProgramReg?.CustomerType || '' : ''}
                    iconLabelStyle={!groupClass?.Event ? 'badge' : undefined}
                    collapsable={!nlt.includes((Type || 'unknown').toLowerCase()) && isEmpty(groupClass?.Event)}
                    collapsableMargin={isEmpty(groupClass?.Event)}
                    onCollapse={() => {
                      if (includes(collapsedItems, Id)) {
                        this.setState({
                          collapsedItems: collapsedItems.filter((item) => item !== Id),
                        })
                      } else {
                        this.setState({
                          collapsedItems: [...collapsedItems, Id],
                        })
                      }
                    }}
                    collapseContent={() => {
                      return (
                        <QueryLessonDetail
                          InstructorId={instructor}
                          StartDateTime={startDate}
                          EndDateTime={endDate}
                          ProgramId={ProgramId}
                          ProgramType={ProgramType}
                          StudentGroupId={StudentGroupId}
                          SessionIds={map(SessionInfoList, 'Id')}
                          SessionInfoList={SessionInfoList}
                          Language={Language}
                          GroupMaterials={SessionMetaData.GroupMaterials}
                          GroupNotes={SessionMetaData.GroupNotes}
                          isFlex={isFlexProgram(groupClass?.Type)}
                          LastMaterialList={LastMaterialList}
                        >
                          {({ loading, data, materialOptions, profile }) => {
                            const units = materialOptions.reduce((p, c) => {
                              p = p.concat(c.Units)
                              return p
                            }, [])
                            return (
                              <>
                                <Content>
                                  {loading ? (
                                    <ViewMaterialLoader />
                                  ) : (
                                    <QueryMaterialData
                                      LastMaterialList={LastMaterialList}
                                      MaterialList={MaterialList}
                                      SessionInfoList={SessionInfoList}
                                      GroupMaterials={SessionMetaData.GroupMaterials}
                                      LessonHistory={data?.LessonHistory}
                                      fetchMaterials
                                      ProgramId={ProgramId}
                                      isFlex={isFlexProgram(groupClass?.Type)}
                                      isBoD1={isBoD1(groupClass?.Type)}
                                    >
                                      {({
                                        loading: queryIsLoading,
                                        error,
                                        errorMessage,
                                        refetch,
                                        LastMaterialList: LastMaterials,
                                        MaterialList: MaterialCol,
                                        GroupMaterials,
                                        activeMaterial,
                                        MaterialOptions: materialOptions2,
                                      }) => {
                                        if (loading || queryIsLoading) {
                                          return <ViewMaterialLoader />
                                        }

                                        if (error) {
                                          return <ViewMaterialError onRetry={refetch} message={errorMessage} />
                                        }

                                        return (
                                          <Materials
                                            GroupName={GroupName}
                                            Materials={MaterialCol}
                                            LastMaterials={LastMaterials}
                                            MaterialOptions={
                                              activeMaterial
                                                ? materialOptions2
                                                : materialOptions?.length
                                                  ? materialOptions
                                                  : materialOptions2
                                            }
                                            Medias={[]}
                                            groupMaterials={GroupMaterials}
                                            studentId={first(map(SessionInfoList, 'CustomerId')) || ''}
                                            note={MINote}
                                            studentProfile={profile}
                                            startDate={startDate}
                                            ProgramType={ProgramType}
                                            StudentGroupId={StudentGroupId}
                                            ProgramId={ProgramId}
                                            isFlex={isFlexProgram(groupClass?.Type)}
                                            isBoD1={isBoD1(groupClass?.Type)}
                                            activeMaterial={activeMaterial}
                                            refetchData={refetch}
                                            SessionInfoList={SessionInfoList}
                                          />
                                        )
                                      }}
                                    </QueryMaterialData>
                                  )}
                                </Content>
                                {data && !isFlexProgram(groupClass?.Type) && !isBoD1(groupClass?.Type) && (
                                  <Content>
                                    {loading ? (
                                      <NotesLoader />
                                    ) : (
                                      <QueryNotesData
                                        GroupNotes={SessionMetaData.GroupNotes}
                                        data={data}
                                        InstructorId={instructor}
                                        StartDateTime={startDate}
                                        EndDateTime={endDate}
                                        ProgramId={ProgramId}
                                        Language={Language}
                                      >
                                        {({ loading: noteIsLoading, error: noteError, refetch, GroupNotes }) => {
                                          if (noteIsLoading) {
                                            return <NotesLoader />
                                          }

                                          if (noteError) {
                                            return <NotesError onRetry={refetch} />
                                          }

                                          return <Notes comments={data.Notes} groupComments={GroupNotes} />
                                        }}
                                      </QueryNotesData>
                                    )}
                                  </Content>
                                )}
                                <Content>
                                  <RecordTableOverride>
                                    {loading ? (
                                      <>
                                        <Row>
                                          <Col xs={12} md={8} className="no-padding">
                                            <StyledH2>{intl.formatMessage({ id: 'Last lessons' })}</StyledH2>
                                          </Col>
                                        </Row>
                                        <TableLoader />
                                        <Row>
                                          <Col xs={12} md={8} className="no-padding">
                                            <StyledH2>{intl.formatMessage({ id: 'Last lessons with me' })}</StyledH2>
                                          </Col>
                                        </Row>
                                        <TableLoader />
                                      </>
                                    ) : (
                                      <>
                                        <RecordTableContainer
                                          title="Last lessons"
                                          displayLessonsBtn={false}
                                          id={SessionInfoList?.[0]?.CustomerId}
                                          fromDate={getEarliestFromDate(profile)}
                                          endDate={lessonEndDate}
                                          learningPaths={materialOptions}
                                          students={SessionInfoList}
                                          profile={this.props.profile}
                                          isFlex={isFlexProgram(groupClass?.Type)}
                                          isBoD1={isBoD1(groupClass?.Type)}
                                          language={Language}
                                          units={units}
                                          isLiveCoachingSession={this.props.isLiveCoachingSession({
                                            Type,
                                          } as GroupClassListItem)}
                                          ProgramIds=""
                                        />
                                        <Spacer />
                                        <RecordTableContainer
                                          currentInstructor
                                          title="Last lessons with me"
                                          displayLessonsBtn={false}
                                          id={SessionInfoList?.[0]?.CustomerId}
                                          fromDate={getEarliestFromDate(profile)}
                                          endDate={lessonEndDate}
                                          learningPaths={materialOptions}
                                          students={SessionInfoList}
                                          profile={this.props.profile}
                                          isFlex={isFlexProgram(groupClass?.Type)}
                                          isBoD1={isBoD1(groupClass?.Type)}
                                          language={Language}
                                          units={units}
                                          isLiveCoachingSession={this.props.isLiveCoachingSession({
                                            Type,
                                          } as GroupClassListItem)}
                                          ProgramIds=""
                                        />
                                      </>
                                    )}
                                  </RecordTableOverride>
                                </Content>
                                {!isBoD1(groupClass?.Type) && (
                                  <Content>
                                    <QueryProfilesData
                                      ProgramType={ProgramType}
                                      StudentGroupId={StudentGroupId}
                                      Language={Language}
                                    >
                                      {({ loading: profileIsLoading, error: profileError, refetch, Profiles }) => {
                                        if (profileIsLoading) {
                                          return <TableLoader />
                                        }

                                        if (profileError) {
                                          return <StudyPurposeError onRetry={refetch} />
                                        }

                                        return (
                                          <StudyPurpose
                                            profiles={Profiles}
                                            groupName={GroupName}
                                            groupId={StudentGroupId}
                                            showLearningProfile={() => {
                                              this.handleViewProfile(
                                                StudentGroupId,
                                                GroupName,
                                                ProgramId,
                                                Language,
                                                true,
                                                ProgramType === 'Individual',
                                                SessionInfoList
                                              )
                                            }}
                                          />
                                        )
                                      }}
                                    </QueryProfilesData>
                                  </Content>
                                )}
                                {/*
                              <Content>
                              <Report />
                              </Content>
                              */}
                              </>
                            )
                          }}
                        </QueryLessonDetail>
                      )
                    }}
                  >
                    <ContentBox>
                      <Row>
                        {groupClass?.Event ? (
                          <Col xs={12} lg={false}>
                            <EventJoinOnlineBtnWrapper smallSizes>
                              <EventJoinOnlineBtn berlitzEventAttendeeInfo={groupClass?.Event} fullWidth={false} />
                            </EventJoinOnlineBtnWrapper>
                          </Col>
                        ) : (
                          <Col xs={12} lg={false}>
                            <EventJoinOnlineBtnWrapper smallSizes>
                              <Indicators
                                status={lowerFirst(Status || '')}
                                lessons={
                                  lessonsRemaining <= 5 && !isFlexProgram(groupClass?.Type) ? lessonsRemaining : 0
                                }
                                type={Type}
                                instructor={instructor}
                                studentId={SessionInfoList?.[0]?.CustomerId}
                                sessionId={SessionId}
                                programId={ProgramId}
                                programType={ProgramType}
                                startDate={this.queryDateFormat(SessionMetaData.StartTime)}
                                endDate={this.queryDateFormat(SessionMetaData.EndTime)}
                                at={SessionMetaData.Index}
                                isPastTime={this.isPastTime(EndTime)}
                                lessonRegistered={LessonRegistered}
                                isCutOff={isCutOff}
                                isAbsent={isAbsent}
                                isCollapsed={isCollapsed}
                                lesson={groupClass}
                                attachment={SessionInfoList?.[0]?.Attachments}
                                notes={SessionInfoList?.[0]?.StudentNote}
                                setAttachments={setAttachments}
                                setOpenFileModal={setOpenFileModal}
                                setNote={setNote}
                                setOpenNoteModal={setOpenNoteModal}
                                hasStudent={Boolean(SessionInfoList.length)}
                                isBoD1={isBoD1(groupClass?.Type)}
                              />
                              <JoinLessonButton
                                lesson={groupClass}
                                className="i__my-sched_jlbtn"
                                startTimeOverride={this.queryDateFormat(SessionMetaData.StartTime)}
                                endTimeOverride={this.queryDateFormat(SessionMetaData.EndTime)}
                                studentId={first(map(SessionInfoList, 'CustomerId')) || ''}
                              />
                              <SelfTechCheck
                                {...groupClass}
                                className="i__my-sched_stbtn"
                                endTimeOverride={this.queryDateFormat(SessionMetaData.EndTime)}
                              />
                            </EventJoinOnlineBtnWrapper>
                          </Col>
                        )}
                        <Col xs={12} sm={12} md={12} lg={8}>
                          <StyledRow>
                            {crossOverDate && (
                              <StyledCol xs={12}>
                                <LessonDate>{crossOverDate}</LessonDate>
                                <Spacer size="xxs" />
                              </StyledCol>
                            )}
                            {groupClass?.Event ? (
                              <MyLessonEvent>
                                {groupClass?.Event && groupClass?.Event?.Language && (
                                  <div id="delivery-language">
                                    {`${intl.formatMessage({
                                      id: 'Delivery language',
                                      defaultMessage: 'Delivery language',
                                    })}:`}
                                    <div id="language">{groupClass?.Event?.Language}</div>
                                  </div>
                                )}

                                {groupClass?.Event?.EventDisplayName ? (
                                  <div className="with-name">
                                    <div id="name">{groupClass?.Event?.EventDisplayName}</div>

                                    <div className="date-time">
                                      <div id="date">{DisplayDate}</div>
                                      <div id="middot">&middot;</div>
                                      <div id="time">{DisplayTime}</div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="date-time">
                                    <div id="date">{DisplayDate}</div>
                                    <div id="time">{DisplayTime}</div>
                                  </div>
                                )}
                                {groupClass?.Event?.VirtualClassRoomProvider && (
                                  <StyledCol xs={12} className="margin-bottom-xxs no-padding-bottom">
                                    <LessonProfile>
                                      <Building /><p>Online ({groupClass?.Event?.VirtualClassRoomProvider})</p>
                                    </LessonProfile>
                                  </StyledCol>
                                )}
                                <Link
                                  href={`/events/?id=${groupClass?.Event?.EventId}&start=${groupClass?.Event?.StartDatetime}&end=${groupClass?.Event?.EndDatetime}${recId}`}
                                  id="more-info"
                                >
                                  {`${intl.formatMessage({
                                    id: 'More info',
                                    defaultMessage: 'More info',
                                  })}`}
                                </Link>
                              </MyLessonEvent>
                            ) : (
                              <>
                                <StyledCol xs={12} className="no-padding-bottom">
                                  <Time>
                                    <PortalTimeFormat
                                      datetime={DisplayTime?.split(' - ')}
                                      format={[DATE_FORMAT.HM, DATE_FORMAT.HM]}
                                      separator=" - "
                                    />
                                  </Time>
                                </StyledCol>
                                <StyledCol xs={12} md={12} lg={10} className="margin-bottom-xxs no-padding-bottom">
                                  <LessonProfile>
                                    {GroupName && (
                                      <>
                                        <IconProfile />{' '}
                                        <GroupedName>
                                          <a
                                            onClick={() => {
                                              this.handleViewProfile(
                                                StudentGroupId,
                                                GroupName,
                                                ProgramId,
                                                Language,
                                                true,
                                                ProgramType === 'Individual',
                                                SessionInfoList
                                              )
                                            }}
                                          >
                                            {GroupName}
                                          </a>
                                          {ProgramReg?.ProgramName && (
                                            <MiniProgramName>{`(${ProgramReg?.ProgramName})`}</MiniProgramName>
                                          )}
                                        </GroupedName>
                                      </>
                                    )}
                                  </LessonProfile>
                                </StyledCol>
                                <StyledCol xs={12} className="margin-bottom-xxs no-padding-bottom">
                                  <LessonProfile>
                                    <Building /><p>{this.identifyLocation(LearningCenter, Type, groupClass.VirtualClassRoomProvider)}</p>
                                  </LessonProfile>
                                </StyledCol>
                                {Classroom ? (
                                  <StyledCol xs={12} md={12} lg={10} className="margin-bottom-xxs no-padding-bottom">
                                    <LessonProfile>
                                      <ClassroomLocation /> <p>{Classroom}</p>
                                    </LessonProfile>
                                  </StyledCol>
                                ) : (
                                  <StyledCol xs={12} md={12} lg={10} className="margin-bottom-xxs no-padding-bottom">
                                    {!isProgramOnline && (
                                      <LessonProfile>
                                        <ClassroomLocation />
                                        <p className="room-to-be-confirmed">
                                          <FormattedMessage id="Room to be confirmed" />
                                        </p>
                                        <span className="room-to-be-confirmed-tooltip">
                                          <Tooltip
                                            message={`${intl.formatMessage({
                                              id: 'Your room will be confirmed after 5pm the day before your class',
                                            })}.`}
                                            placement="top"
                                          >
                                            <Info size="xs" />
                                          </Tooltip>
                                        </span>
                                      </LessonProfile>
                                    )}
                                  </StyledCol>
                                )}
                              </>
                            )}
                            {TotalLessons > 0 && !isFlexProgram(groupClass?.Type) && (
                              <StyledCol xs={12} className="margin-bottom-xxs no-padding-bottom">
                                <LessonProfile>
                                  <CalendarSearch />
                                  <GroupedName>
                                    <p>
                                      <FormattedMessage
                                        id="{TotalLessons, plural, zero {# none} one {# lesson} other {# lessons}} {LessonRemaining, plural, zero {(# none)} other {(# remaining)}}"
                                        defaultMessage="{TotalLessons, plural, zero {# none} one {# lesson} other {# lessons}} {LessonRemaining, plural, zero {(# none)} other {(# remaining)}}"
                                        values={{
                                          TotalLessons,
                                          LessonRemaining: lessonsRemaining,
                                        }}
                                      />
                                    </p>
                                    {Boolean(atRiskData.length) &&
                                      atRiskData.map((risk, idx) => {
                                        const values = {
                                          student: risk.atRiskStudent,
                                          lessonCount: risk.lessonsLeft,
                                        }
                                        return (
                                          <AtRiskText key={idx}>
                                            <LessonProfile>
                                              <WarningTriangle className="margin-right-8" />
                                              <p>
                                                <FormattedMessage
                                                  id="{student} needs to book {lessonCount} lessons"
                                                  defaultMessage="{student} needs to book {lessonCount} lessons"
                                                  values={values}
                                                />
                                              </p>
                                            </LessonProfile>
                                          </AtRiskText>
                                        )
                                      })}
                                  </GroupedName>
                                </LessonProfile>
                              </StyledCol>
                            )}

                            {ProgramReg?.Language && (
                              <StyledCol xs={12} md={12} lg={10} className="margin-bottom-xxs no-padding-bottom">
                                <LessonProfile>
                                  <PerfTablet />
                                  <p>
                                    {ProgramReg.Language} {ProgramReg.FromRegistration?.LanguageLevel}
                                  </p>
                                </LessonProfile>
                              </StyledCol>
                            )}
                            {!!ProgramReg?.FromRegistration?.Materials?.length && (
                              <StyledCol xs={12} md={12} lg={10} className="margin-bottom-xxs no-padding-bottom">
                                <LessonProfile longContent={true}>
                                  <BookFlip />
                                  <p>
                                    {ProgramReg.FromRegistration.Materials.filter(
                                      (material) => !material.IsTest && !/MyBerlitz.*Tutor/.test(material.MaterialName)
                                    )
                                      .map((material) => material.MaterialName)
                                      .join(' | ')}
                                  </p>
                                </LessonProfile>
                              </StyledCol>
                            )}
                          </StyledRow>
                        </Col>
                        {groupClass?.Event ? (
                          <Col xs={false} md={false} lg={4}>
                            <EventOpenMaterialBtn
                              berlitzEventAttendeeInfo={groupClass?.Event}
                              fullWidth={false}
                              onError={(error) => this.setState({ modalEventMaterialError: !!error })}
                              disable={this.isPastTime(groupClass?.Event?.EndDatetime)}
                            />
                            <EventJoinOnlineBtnWrapper>
                              <EventJoinOnlineBtn berlitzEventAttendeeInfo={groupClass?.Event} fullWidth={false} />
                            </EventJoinOnlineBtnWrapper>
                          </Col>
                        ) : (
                          <Col xs={false} md={false} lg={4}>
                            <RightCol className="no-padding">
                              <IndicatorsRow end="xs">
                                <Indicators
                                  status={lowerFirst(Status || '')}
                                  lessons={
                                    lessonsRemaining <= 5 && !isFlexProgram(groupClass?.Type) ? lessonsRemaining : 0
                                  }
                                  type={Type}
                                  instructor={instructor}
                                  studentId={SessionInfoList?.[0]?.CustomerId}
                                  sessionId={SessionId}
                                  programId={ProgramId}
                                  programType={ProgramType}
                                  startDate={this.queryDateFormat(SessionMetaData.StartTime)}
                                  endDate={this.queryDateFormat(SessionMetaData.EndTime)}
                                  at={SessionMetaData.Index}
                                  isPastTime={this.isPastTime(EndTime)}
                                  lessonRegistered={LessonRegistered}
                                  isCutOff={isCutOff}
                                  isAbsent={isAbsent}
                                  isCollapsed={isCollapsed}
                                  lesson={groupClass}
                                  attachment={SessionInfoList?.[0]?.Attachments}
                                  notes={SessionInfoList?.[0]?.StudentNote}
                                  setAttachments={setAttachments}
                                  setOpenFileModal={setOpenFileModal}
                                  setNote={setNote}
                                  setOpenNoteModal={setOpenNoteModal}
                                  hasStudent={Boolean(SessionInfoList.length)}
                                />
                                <>
                                  <JoinLessonButton
                                    lesson={groupClass}
                                    className="i__my-sched_jlbtn"
                                    startTimeOverride={this.queryDateFormat(SessionMetaData.StartTime)}
                                    endTimeOverride={this.queryDateFormat(SessionMetaData.EndTime)}
                                    studentId={first(map(SessionInfoList, 'CustomerId')) || ''}
                                  />
                                  <SelfTechCheck
                                    {...groupClass}
                                    className="i__my-sched_stbtn"
                                    endTimeOverride={this.queryDateFormat(SessionMetaData.EndTime)}
                                  />
                                </>
                              </IndicatorsRow>
                              {/* {Bps && (
                              <Row className="margin-top-auto" end="md">
                              <BpsStatus percentage={Bps} />
                              </Row>
                              )} */}
                            </RightCol>
                          </Col>
                        )}
                      </Row>
                    </ContentBox>
                  </ListCard>
                </AtRiskContainer>
              </Spacer>
            )
          })}

        {isIndividual && (
          <SingleProfileModal
            open={modalProfileOpen}
            onClose={() => this.setState({ modalProfileOpen: false })}
            StudentId={groupId}
            StudentName={groupName}
            Language={language}
            ProgramId={programId}
          />
        )}
        {!isIndividual && (
          <GroupProfileModal
            id={groupId}
            open={modalProfileOpen}
            onClose={() => this.setState({ modalProfileOpen: false })}
            groupName={groupName}
            language={language}
            programId={programId}
            students={sessionInfoList}
          />
        )}

        <EventOpenMaterialModal
          open={modalEventMaterialError}
          onClose={() => {
            this.setState({ modalEventMaterialError: false })
            window.location.reload()
          }}
        />
      </Container>
    )
  }
}

export default compose(WithLessonUtilsHOC, WithUserTime, injectIntl, withToaster)(Lessons)
